var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTableRowsNarrow = function SvgTableRowsNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M780 711V606H180v105zm0-165V441H180v105zm0-165V276H180v105zM180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18zm600-60V771H180v105z"
  })));
};
export default SvgTableRowsNarrow;